import { render } from "./BuktiPendaftaran.vue?vue&type=template&id=ae856f56&scoped=true"
import script from "./BuktiPendaftaran.vue?vue&type=script&lang=js"
export * from "./BuktiPendaftaran.vue?vue&type=script&lang=js"

import "./BuktiPendaftaran.vue?vue&type=style&index=0&id=ae856f56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae856f56"]])

export default __exports__